module.exports = __webpack_public_path__ + "img/lightlocation.5baf0bf5.svg";